import LegalLinks from './LegalLinks';
import './LegalLinks.css';

export default LegalLinks;



// WEBPACK FOOTER //
// ./src/components/LegalLinks/index.js